<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main elgrain-modal">
      <div class="title-area" id="modal-moving">
        <h2 v-if="isOneParts">木目設定</h2>
        <h2 v-else>木目一括設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="main-area" v-if="isOneParts">
        <div class="data-area">
          <span>{{ spaceObjName + '（id:' + focusedMenuSpace.id + '）'}}</span>
          <ul>
            <li>
              <div class="label">①{{faceData.face1.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.surfaceGrain"
                    :value="0"
                    :disabled="checkDisableRadio(form.surfaceGrain, form.surfaceId)"
                  />正
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.surfaceGrain"
                    :value="1"
                    :disabled="checkDisableRadio(form.surfaceGrain, form.surfaceId)"
                  />反
                </label>
              </div>
            </li>
            <li>
              <div class="label">②{{faceData.face2.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.backGrain"
                    :value="0"
                    :disabled="checkDisableRadio(form.backGrain, form.backId)"
                  />正
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.backGrain"
                    :value="1"
                    :disabled="checkDisableRadio(form.backGrain, form.backId)"
                  />反
                </label>
              </div>
            </li>
            <li>
              <div class="label">③{{faceData.face3.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberGrain1"
                    :value="0"
                    :disabled="checkDisableRadio(form.lumberGrain1, form.lumber1Id)"
                  />正
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberGrain1"
                    :value="1"
                    :disabled="checkDisableRadio(form.lumberGrain1, form.lumber1Id)"
                  />反
                </label>
              </div>
            </li>
            <li>
              <div class="label">④{{faceData.face4.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberGrain2"
                    :value="0"
                    :disabled="checkDisableRadio(form.lumberGrain2, form.lumber2Id)"
                  />正
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberGrain2"
                    :value="1"
                    :disabled="checkDisableRadio(form.lumberGrain2, form.lumber2Id)"
                  />反
                </label>
              </div>
            </li>
            <li>
              <div class="label">⑤{{faceData.face5.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberGrain3"
                    :value="0"
                    :disabled="checkDisableRadio(form.lumberGrain3, form.lumber3Id)"
                  />正
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberGrain3"
                    :value="1"
                    :disabled="checkDisableRadio(form.lumberGrain3, form.lumber3Id)"
                  />反
                </label>
              </div>
            </li>
            <li>
              <div class="label">⑥{{faceData.face6.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberGrain4"
                    :value="0"
                    :disabled="checkDisableRadio(form.lumberGrain4, form.lumber4Id)"
                  />正
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.lumberGrain4"
                    :value="1"
                    :disabled="checkDisableRadio(form.lumberGrain4, form.lumber4Id)"
                  />反
                </label>
              </div>
            </li>
            <li>
              <div class="label">⑦{{faceData.face7.objName}}</div>
              <div class="input">
                <label>
                  <input
                    type="radio"
                    v-model="form.coreGrain"
                    :value="0"
                    :disabled="checkDisableRadio(form.coreGrain, form.coreId)"
                  />正
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="form.coreGrain"
                    :value="1"
                    :disabled="checkDisableRadio(form.coreGrain, form.coreId)"
                  />反
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="preview-area">
          <div class="face-area">
            <svg :width="this.svgSize" :height="this.svgSize" :viewBox="dispViewBox">
              <!-- パーツ -->
              <rect
                :x="(this.svgSize - previewData.width) / 2"
                :y="(this.svgSize - previewData.height) / 2"
                :width="previewData.width"
                :height="previewData.height"
                stroke="black"
                fill="white"
              />
              <!-- 木目マーク -->
              <g
                v-for="(grain, index) in firstGrainLineList"
                :key="'grain_' + index"
                fill="none"
                stroke="black"
              >
                <line
                  :x1="grain.startX"
                  :y1="grain.startY"
                  :x2="grain.endX"
                  :y2="grain.endY"
                  z="0"
                  stroke="black"/>
                <path
                  :d="'M ' + (grain.startX + arrow) +' ' + (grain.startY + arrow)
                    + ' l ' + -arrow + ' ' + -arrow
                    + ' l ' + arrow + ' ' + -arrow"
                  :transform="'rotate(' + grain.angle + ', ' + grain.startX +', ' + grain.startY + ')'"/>
                <path
                  :d="'M ' +  (grain.endX - arrow) +' ' + (grain.endY + arrow)
                    + ' l ' + arrow + ' ' + -arrow
                    + ' l ' + -arrow + ' ' + -arrow"
                  :transform="'rotate(' + grain.angle + ', ' + grain.endX +', ' + grain.endY + ')'"/>
              </g>
              <!-- 木目No -->
              <g
                v-for="(num, index) in firstNumberList"
                :key="'num' + index"
              >
               <text :x="num.x" :y="num.y" :font-size="fontSize">{{num.label}}</text>
              </g>
            </svg>
            <div class="face-name">
              <span>{{ faceData.face1.name }}</span>
            </div>
          </div>
          <div class="face-area">
            <svg :width="this.svgSize" :height="this.svgSize" :viewBox="dispViewBox">
              <!-- パーツ -->
              <rect
                :x="(this.svgSize - previewData.width) / 2"
                :y="(this.svgSize - previewData.height) / 2"
                :width="previewData.width"
                :height="previewData.height"
                stroke="black"
                fill="white"
              />
              <!-- 木目マーク -->
              <g
                v-for="(grain, index) in secondGrainLineList"
                :key="'grain_' + index"
                fill="none"
                stroke="black"
              >
                <line
                  :x1="grain.startX"
                  :y1="grain.startY"
                  :x2="grain.endX"
                  :y2="grain.endY"
                  z="0"
                  stroke="black"/>
                <path
                  :d="'M ' + (grain.startX + arrow) +' ' + (grain.startY + arrow)
                    + ' l ' + -arrow + ' ' + -arrow
                    + ' l ' + arrow + ' ' + -arrow"
                  :transform="'rotate(' + grain.angle + ', ' + grain.startX +', ' + grain.startY + ')'"/>
                <path
                  :d="'M ' +  (grain.endX - arrow) +' ' + (grain.endY + arrow)
                    + ' l ' + arrow + ' ' + -arrow
                    + ' l ' + -arrow + ' ' + -arrow"
                  :transform="'rotate(' + grain.angle + ', ' + grain.endX +', ' + grain.endY + ')'"/>
              </g>
              <!-- 木目No -->
              <g
                v-for="(num, index) in secondNumberList"
                :key="'num' + index"
              >
               <text :x="num.x" :y="num.y" :font-size="fontSize">{{num.label}}</text>
              </g>
            </svg>
            <div class="face-name">
              <span>{{ faceData.face2.name }}</span>
            </div>
          </div>
        </div>
        <div class="errormessage-area">
        </div>
      </div>
      <div class="main-area" v-else>
        <span>指定配下の板材の木目を一括設定します。</span>
          <div class="input">
            <div class="data-area">
              <ul>
                <li>
                  <div class="input">
                    <label>
                      <input
                        type="radio"
                        v-model="form.totalGrain"
                        :value="0"
                      />正
                    </label>
                    <label>
                      <input
                        type="radio"
                        v-model="form.totalGrain"
                        :value="1"
                      />反
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <img :src="getImage('pages/planning/grain_pic.png')" alt="allview" width="700" height="auto" >
          </div>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="updateElGrain">登録</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import {ATTRIBUTE_KEY, FACE_TYPE} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import * as SpaceUtil from '../../../utils/Space'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'SetElGrainModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    focusedMenuSpace: Object
  },
  data () {
    return {
      modalShown: false,
      form: {
        spaceId: '',
        isOnePartsFlg: true,
        totalGrain: '',
        surfaceId: '',
        surfaceGrain: '',
        backId: '',
        backGrain: '',
        lumber1Id: '',
        lumberGrain1: '',
        lumber2Id: '',
        lumberGrain2: '',
        lumber3Id: '',
        lumberGrain3: '',
        lumber4Id: '',
        lumberGrain4: '',
        coreId: '',
        coreGrain: ''
      },
      /** 選択空間 */
      selectedSpace: {},
      /** 選択空間オブジェクト名 */
      spaceObjName: '',
      /** アトリビュート情報 */
      dirAtt: {},
      /** プレビュー表示用データ */
      previewData: {
        width: '',
        height: '',
        processX: '',
        processY: '',
        processRX: '',
        processRY: '',
        processW: '',
        processH: ''
      },
      /** プレビュー表示木目データ */
      grainLineList: [],
      /** プレビューの数字位置 */
      firstNumberList: [],
      secondNumberList: [],
      /** プレビュー表示エリアサイズ */
      svgSize: 350,
      /** プレビュー縮尺率 */
      previewRatio: 1,
      /** 矢印のサイズ */
      arrow: 5,
      /** パーツから木目マークまでの距離 */
      outsideDist: 20,
      /** フォントサイズ */
      fontSize: 12,
      /** 表示対象面 */
      faceData: {
        face1: {
          name: '',
          code: '',
          objName: ''
        },
        face2: {
          name: '',
          code: '',
          objName: ''
        },
        face3: {
          name: '',
          code: '',
          objName: ''
        },
        face4: {
          name: '',
          code: '',
          objName: ''
        },
        face5: {
          name: '',
          code: '',
          objName: ''
        },
        face6: {
          name: '',
          code: '',
          objName: ''
        },
        face7: {
          name: '',
          code: '',
          objName: ''
        }
      },
      isOneParts: true,
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
    dispViewBox: function () {
      return 0 + ' ' + 0 + ' ' + this.svgSize + ' ' + this.svgSize
    },
    firstGrainLineList: function () {
      // 後面は非表示
      return this.grainLineList
        .filter(grain => grain.faceType !== FACE_TYPE.BACK)
        .filter(grain => grain.angle !== '')
    },
    secondGrainLineList: function () {
      let list = []
      // 裏面は左右の木目マークを反転
      this.grainLineList
        .filter(grain => grain.faceType !== FACE_TYPE.FRONT)
        .forEach(grain => {
          let newGrain = Object.assign({}, grain)
          if (grain.faceType === FACE_TYPE.RIGHT && grain.angle !== '') {
            newGrain.startX = newGrain.startX - (this.previewData.width + this.outsideDist * 2)
            newGrain.endX = newGrain.endX - (this.previewData.width + this.outsideDist * 2)
            newGrain.faceType = FACE_TYPE.LEFT
          } else if (grain.faceType === FACE_TYPE.LEFT && grain.angle !== '') {
            newGrain.startX = newGrain.startX + (this.previewData.width + this.outsideDist * 2)
            newGrain.endX = newGrain.endX + (this.previewData.width + this.outsideDist * 2)
            newGrain.faceType = FACE_TYPE.RIGHT
          }
          list.push(newGrain)
        })
      return list.filter(grain => grain.angle !== '')
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    form: {
      handler: function () {
        this.onPreview()
      },
      deep: true
    },
    firstGrainLineList: function () {
      this.firstNumberList = this.createNumberList(true)
    },
    secondGrainLineList: function () {
      this.secondNumberList = this.createNumberList(false)
    }
  },
  methods: {
    /** 木目設定モーダル表示 */
    showModal: function () {
      this.clearData()
      this.form.spaceId = this.focusedMenuSpace.id
      this.getPartsData()
      this.showPartsPreview()
      this.isOneParts = true
      this.modalShown = true
    },
    /** 木目一括設定モーダル表示 */
    showAllPartsModal: function () {
      this.clearData()
      this.form.spaceId = this.focusedMenuSpace.id
      this.isOneParts = false
      this.modalShown = true
    },
    /** モーダルキャンセル */
    onCancel: function () {
      this.$emit('closeTreeContextModal')
      this.modalShown = false
    },
    /** パーツ情報の取得 */
    getPartsData: function () {
      this.selectedSpace = SpaceUtil.searchSpaceTree(this.form.spaceId, this.fileData.topSpaceModel)
      this.dirAtt = this.fileData.attributeModelList.find(att => {
        return att.attKeycd === ATTRIBUTE_KEY.PT_FLAG_DIR && att.spaceId === this.form.spaceId
      })
      this.spaceObjName = this.fileData.objectDataModelList.find(obj => {
        return obj.spaceId === this.form.spaceId
      }).objName
      // 表示用の面の設定
      switch (this.dirAtt.attValue1) {
        case 1:
          this.faceData.face1 = {name: '上面', code: 3}
          this.faceData.face2 = {name: '下面', code: 4}
          this.faceData.face3 = {name: '後面', code: 6}
          this.faceData.face4 = {name: '右面', code: 1}
          this.faceData.face5 = {name: '前面', code: 5}
          this.faceData.face6 = {name: '左面', code: 2}
          break
        case 2:
          this.faceData.face1 = {name: '左面', code: 2}
          this.faceData.face2 = {name: '右面', code: 1}
          this.faceData.face3 = {name: '上面', code: 3}
          this.faceData.face4 = {name: '前面', code: 5}
          this.faceData.face5 = {name: '下面', code: 4}
          this.faceData.face6 = {name: '後面', code: 6}
          break
        case 3:
          this.faceData.face1 = {name: '前面', code: 5}
          this.faceData.face2 = {name: '後面', code: 6}
          this.faceData.face3 = {name: '上面', code: 3}
          this.faceData.face4 = {name: '右面', code: 1}
          this.faceData.face5 = {name: '下面', code: 4}
          this.faceData.face6 = {name: '左面', code: 2}
          break
        default:
      }
      this.faceData.face7 = {name: '芯材', code: 7}
      this.getGrainData()
    },
    /** 木目情報の取得 */
    getGrainData: function () {
      let objectList = []
      axios.get(API_URL.PLANNING + '/object/' + this.focusedMenuSpace.id)
        .then(response => {
          objectList = response.data.data
          objectList.forEach(elObj => {
            // 木目ロックの判定フラグ
            let lockFlg = [2, 3].includes(elObj.objElMaterialLockFlg)
            switch (elObj.objElFaceType) {
              case this.faceData.face1.code:
                this.form.surfaceId = elObj.objEnableFlag === 1 && !lockFlg ? elObj.spaceId : ''
                this.form.surfaceGrain = elObj.objElGrain
                this.faceData.face1.objName = elObj.objName
                break
              case this.faceData.face2.code:
                this.form.backId = elObj.objEnableFlag === 1 && !lockFlg ? elObj.spaceId : ''
                this.form.backGrain = elObj.objElGrain
                this.faceData.face2.objName = elObj.objName
                break
              case this.faceData.face3.code:
                this.form.lumber1Id = elObj.objEnableFlag === 1 && !lockFlg ? elObj.spaceId : ''
                this.form.lumberGrain1 = elObj.objElGrain
                this.faceData.face3.objName = elObj.objName
                break
              case this.faceData.face4.code:
                this.form.lumber2Id = elObj.objEnableFlag === 1 && !lockFlg ? elObj.spaceId : ''
                this.form.lumberGrain2 = elObj.objElGrain
                this.faceData.face4.objName = elObj.objName
                break
              case this.faceData.face5.code:
                this.form.lumber3Id = elObj.objEnableFlag === 1 && !lockFlg ? elObj.spaceId : ''
                this.form.lumberGrain3 = elObj.objElGrain
                this.faceData.face5.objName = elObj.objName
                break
              case this.faceData.face6.code:
                this.form.lumber4Id = elObj.objEnableFlag === 1 && !lockFlg ? elObj.spaceId : ''
                this.form.lumberGrain4 = elObj.objElGrain
                this.faceData.face6.objName = elObj.objName
                break
              case this.faceData.face7.code:
                this.form.coreId = elObj.objEnableFlag === 1 && !lockFlg ? elObj.spaceId : ''
                this.form.coreGrain = elObj.objElGrain
                this.faceData.face7.objName = elObj.objName
                break
              default:
            }
          })
        }).catch(error => {
          Api.handleError(error)
        })
    },
    /** 変更可能項目のチェック */
    checkDisableRadio: function (grain, id) {
      return grain === 9 || id === ''
    },
    /** 木目情報の更新 */
    updateElGrain: function () {
      this.form.isOnePartsFlg = this.isOneParts
      let payload = this.form
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.PLANNING + '/el-grain/update', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          this.$emit('closeTreeContextModal')
          this.modalShown = false
          AppUtil.showModal({
            messages: ['変更しました。']
          })
          this.$emit('setResponseData', response)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    /** パーツのプレビュー表示 */
    showPartsPreview: function () {
      // 上下(1),左右(2),前後(3)
      switch (this.dirAtt.attValue1) {
        case 1:
          this.previewData.width = this.selectedSpace.w
          this.previewData.height = this.selectedSpace.d
          break
        case 2:
          this.previewData.width = this.selectedSpace.d
          this.previewData.height = this.selectedSpace.h
          break
        case 3:
          this.previewData.width = this.selectedSpace.w
          this.previewData.height = this.selectedSpace.h
          break
        default:
      }
      this.calcPreviewRatio()
      this.previewData.width = this.previewData.width * this.previewRatio
      this.previewData.height = this.previewData.height * this.previewRatio
    },
    /** 縮尺率の計算 */
    calcPreviewRatio: function () {
      if (this.previewData.width > this.svgSize * 0.8 || this.previewData.height > this.svgSize * 0.8) {
        let widthRatio = this.svgSize / this.previewData.width
        let heightRatio = this.svgSize / this.previewData.height
        this.previewRatio = widthRatio > heightRatio ? heightRatio * 0.7 : widthRatio * 0.7
      } else {
        this.previewRatio = 0.8
      }
    },
    /** 木目マークの表示 */
    onPreview: function () {
      let posX = (this.svgSize - this.previewData.width) / 2
      let posY = (this.svgSize - this.previewData.height) / 2
      // 表裏面材に指定がなければ芯材に置き換え
      let surfaceGrain = this.form.surfaceGrain === 9 ? this.form.coreGrain : this.form.surfaceGrain
      let backGrain = this.form.backGrain === 9 ? this.form.coreGrain : this.form.backGrain
      // 板方向が水平の場合は、木目マークの向きを入れ替え
      if (this.dirAtt.attValue1 === 1) {
        surfaceGrain = surfaceGrain === 0 ? 1 : surfaceGrain === 1 ? 0 : surfaceGrain
        backGrain = backGrain === 0 ? 1 : backGrain === 1 ? 0 : backGrain
      }
      // 木目が0(正)か1(反)の場合のみ値を設定
      this.grainLineList = [
        {
          faceType: FACE_TYPE.FRONT,
          startX: surfaceGrain === 0 ? posX + this.previewData.width / 2 : surfaceGrain === 1 ? posX + this.previewData.width * 0.25 : '',
          startY: surfaceGrain === 0 ? posY + this.previewData.height * 0.25 : surfaceGrain === 1 ? posY + this.previewData.height / 2 : '',
          endX: surfaceGrain === 0 ? posX + this.previewData.width / 2 : surfaceGrain === 1 ? posX + this.previewData.width * 0.75 : '',
          endY: surfaceGrain === 0 ? posY + this.previewData.height * 0.75 : surfaceGrain === 1 ? posY + this.previewData.height / 2 : '',
          angle: surfaceGrain === 0 ? 90 : surfaceGrain === 1 ? 0 : ''
        },
        {
          faceType: FACE_TYPE.BACK,
          startX: backGrain === 0 ? posX + this.previewData.width / 2 : backGrain === 1 ? posX + this.previewData.width * 0.25 : '',
          startY: backGrain === 0 ? posY + this.previewData.height * 0.25 : backGrain === 1 ? posY + this.previewData.height / 2 : '',
          endX: backGrain === 0 ? posX + this.previewData.width / 2 : backGrain === 1 ? posX + this.previewData.width * 0.75 : '',
          endY: backGrain === 0 ? posY + this.previewData.height * 0.75 : backGrain === 1 ? posY + this.previewData.height / 2 : '',
          angle: backGrain === 0 ? 90 : backGrain === 1 ? 0 : ''
        },
        { faceType: FACE_TYPE.TOP,
          startX: this.form.lumberGrain1 === 0 ? posX + this.previewData.width * 0.25 : this.form.lumberGrain1 === 1 ? posX + this.previewData.width / 2 : '',
          startY: this.form.lumberGrain1 === 0 ? posY - this.outsideDist : this.form.lumberGrain1 === 1 ? posY - 35 : '',
          endX: this.form.lumberGrain1 === 0 ? posX + this.previewData.width * 0.75 : this.form.lumberGrain1 === 1 ? posX + this.previewData.width / 2 : '',
          endY: this.form.lumberGrain1 === 0 ? posY - this.outsideDist : this.form.lumberGrain1 === 1 ? posY - 5 : '',
          angle: this.form.lumberGrain1 === 0 ? 0 : this.form.lumberGrain1 === 1 ? 90 : ''
        },
        { faceType: FACE_TYPE.RIGHT,
          startX: this.form.lumberGrain2 === 0 ? posX + this.previewData.width + this.outsideDist : this.form.lumberGrain2 === 1 ? posX + this.previewData.width + 5 : '',
          startY: this.form.lumberGrain2 === 0 ? posY + this.previewData.height * 0.25 : this.form.lumberGrain2 === 1 ? posY + this.previewData.height / 2 : '',
          endX: this.form.lumberGrain2 === 0 ? posX + this.previewData.width + this.outsideDist : this.form.lumberGrain2 === 1 ? posX + this.previewData.width + 35 : '',
          endY: this.form.lumberGrain2 === 0 ? posY + this.previewData.height * 0.75 : this.form.lumberGrain2 === 1 ? posY + this.previewData.height / 2 : '',
          angle: this.form.lumberGrain2 === 0 ? 90 : this.form.lumberGrain2 === 1 ? 0 : ''
        },
        {
          faceType: FACE_TYPE.BOTTOM,
          startX: this.form.lumberGrain3 === 0 ? posX + this.previewData.width * 0.25 : this.form.lumberGrain3 === 1 ? posX + this.previewData.width / 2 : '',
          startY: this.form.lumberGrain3 === 0 ? posY + this.previewData.height + this.outsideDist : this.form.lumberGrain3 === 1 ? posY + this.previewData.height + 5 : '',
          endX: this.form.lumberGrain3 === 0 ? posX + this.previewData.width * 0.75 : this.form.lumberGrain3 === 1 ? posX + this.previewData.width / 2 : '',
          endY: this.form.lumberGrain3 === 0 ? posY + this.previewData.height + this.outsideDist : this.form.lumberGrain3 === 1 ? posY + this.previewData.height + 35 : '',
          angle: this.form.lumberGrain3 === 0 ? 0 : this.form.lumberGrain3 === 1 ? 90 : ''
        },
        {
          faceType: FACE_TYPE.LEFT,
          startX: this.form.lumberGrain4 === 0 ? posX - this.outsideDist : this.form.lumberGrain4 === 1 ? posX - 35 : '',
          startY: this.form.lumberGrain4 === 0 ? posY + this.previewData.height * 0.25 : this.form.lumberGrain4 === 1 ? posY + this.previewData.height / 2 : '',
          endX: this.form.lumberGrain4 === 0 ? posX - this.outsideDist : this.form.lumberGrain4 === 1 ? posX - 5 : '',
          endY: this.form.lumberGrain4 === 0 ? posY + this.previewData.height * 0.75 : this.form.lumberGrain4 === 1 ? posY + this.previewData.height / 2 : '',
          angle: this.form.lumberGrain4 === 0 ? 90 : this.form.lumberGrain4 === 1 ? 0 : ''
        }
      ]
    },
    /** 木目マークに対応する数字の表示位置を設定 */
    createNumberList: function (isFirstFace) {
      let numberList = []
      let posX = (this.svgSize - this.previewData.width) / 2
      let posY = (this.svgSize - this.previewData.height) / 2
      // 木目がない場合はパーツの中心、ある場合は木目マークから一定の位置(10)に表示
      if (isFirstFace) {
      // 表面
        let frontGrain = this.getGrain(isFirstFace, FACE_TYPE.FRONT)
        let frontY = !frontGrain ? posY + this.previewData.height * 0.5 + this.fontSize / 2 : frontGrain.startY - 10
        // パーツの表示高さが40より大きいの場合は木目マークの上、40以下の場合は左に表示
        if (!frontGrain || this.previewData.height > 40) {
          numberList.push({label: '①or⑦', x: posX + this.previewData.width / 2 - this.fontSize * 1.5, y: frontY})
        } else {
          numberList.push({label: '①or⑦', x: frontGrain.startX - (10 + this.fontSize * 3), y: posY + this.previewData.height * 0.5 + this.fontSize / 2})
        }
      } else {
      // 裏面
        let backGrain = this.getGrain(isFirstFace, FACE_TYPE.BACK)
        let backY = !backGrain ? posY + this.previewData.height * 0.5 + this.fontSize / 2 : backGrain.startY - 10
        // パーツの表示高さが40より大きいの場合は木目マークの上、40以下の場合は左に表示
        if (!backGrain || this.previewData.height > 40) {
          numberList.push({label: '②or⑦', x: posX + this.previewData.width / 2 - this.fontSize * 1.5, y: backY})
        } else {
          numberList.push({label: '②or⑦', x: backGrain.startX - (10 + this.fontSize * 3), y: posY + this.previewData.height * 0.5 + this.fontSize / 2})
        }
      }
      // 木口１
      let topGrain = this.getGrain(isFirstFace, FACE_TYPE.TOP)
      let topX = !topGrain ? posX + this.previewData.width * 0.5 - this.fontSize / 2 : topGrain.startX - (10 + this.fontSize)
      numberList.push({label: '③', x: topX, y: posY - 10})
      // 木口２
      let rightGrain = this.getGrain(isFirstFace, FACE_TYPE.RIGHT)
      let rightY = !rightGrain ? posY + this.previewData.height * 0.5 + this.fontSize / 2 : rightGrain.startY - 10
      numberList.push({label: isFirstFace ? '④' : '⑥', x: posX + this.previewData.width + 10, y: rightY})
      // 木口３
      let bottomGrain = this.getGrain(isFirstFace, FACE_TYPE.BOTTOM)
      let bottomX = !bottomGrain ? posX + this.previewData.width * 0.5 - this.fontSize / 2 : bottomGrain.startX - (10 + this.fontSize)
      numberList.push({label: '⑤', x: bottomX, y: posY + this.previewData.height + (10 + this.fontSize)})
      // 木口４
      let leftGrain = this.getGrain(isFirstFace, FACE_TYPE.LEFT)
      let leftY = !leftGrain ? posY + this.previewData.height * 0.5 + this.fontSize / 2 : leftGrain.startY - 10
      numberList.push({label: isFirstFace ? '⑥' : '④', x: posX - (10 + this.fontSize), y: leftY})
      return numberList
    },
    /** 指定面の木目マーク情報を取得 */
    getGrain: function (isFirstFace, face) {
      if (isFirstFace) {
        return this.firstGrainLineList.find(grain => grain.faceType === face)
      } else {
        return this.secondGrainLineList.find(grain => grain.faceType === face)
      }
    },
    clearData: function () {
      this.form = {
        spaceId: '',
        isOnePartsFlg: true,
        totalGrain: 0,
        surfaceId: '',
        surfaceGrain: 9,
        backId: '',
        backGrain: 9,
        lumber1Id: '',
        lumberGrain1: 9,
        lumber2Id: '',
        lumberGrain2: 9,
        lumber3Id: '',
        lumberGrain3: 9,
        lumber4Id: '',
        lumberGrain4: 9,
        coreId: '',
        coreGrain: 9
      }
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    },
    getImage: function (image) {
      return AppUtil.getDarosResource(image)
    }
  }
}
</script>
<style lang="scss" scoped>
.elgrain-modal{
  max-height: 100%;
  min-width: 750px;
  max-width: 800px;
}
.main-area {
  max-height: 680px;
}
.data-area{
  margin: 20px auto;
  li{
    margin: 12px 0px;
    .label{
      min-width: 150px;
      display: inline-block;
      text-align: left;
    }
    .input{
      min-width: 140px;
      display: inline-block;
      text-align: left;
      label{
        min-width: 150px;
        text-align: left;
        padding: 0 10px;
        input[type="radio"]{
          margin: 0 3px;
        }
      }
    }
    input[type="number"]{
      width: 100px;
    }
    .input-size{
      display: inline-block;
      vertical-align: top;
      padding: 0 5px;
      .check{
        text-align: center;
      }
    }
  }
  .select-process {
    min-width: 200px;
  }
}
.errormessage-area{
  text-align: left;
  padding: 20px 75px;
}
.preview-area{
  margin: auto;
  .face-area{
    display: inline-block;
    .face-name{
      margin-bottom: 20px;
    }
  }
}
.error_messages{
  margin-left: auto;
  margin-right: auto;
  max-width: 270px;
  min-width: 270px;
}
.error_message {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetElGrainModal.vue